var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8955 4.79742C11.1128 4.45528 11.0116 4.00168 10.6693 3.78436C10.3272 3.56706 9.87346 3.6684 9.65629 4.01055L6.84921 8.43161L4.88294 6.73794C4.57576 6.47338 4.11233 6.50794 3.84778 6.81511C3.58322 7.12215 3.61778 7.58572 3.92495 7.85027L6.53469 10.098C6.69627 10.2372 6.91029 10.2992 7.12131 10.268C7.33219 10.2368 7.51904 10.1154 7.63338 9.93537L10.8955 4.79742Z",
    fill: "#0F9918"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34 0C3.28608 0 0 3.28622 0 7.34C0 11.3936 3.28622 14.68 7.34 14.68C11.3936 14.68 14.68 11.3938 14.68 7.34C14.68 3.28608 11.3938 0 7.34 0ZM1.46786 7.34C1.46786 4.09693 4.09686 1.46786 7.34 1.46786C10.5829 1.46786 13.2118 4.09686 13.2118 7.34C13.2118 10.5829 10.5828 13.2118 7.34 13.2118C4.09693 13.2118 1.46786 10.5828 1.46786 7.34Z",
    fill: "#0F9918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.faad69a76c795d3e8b1e2398f2b9c3bb.svg";
export { ForwardRef as ReactComponent };